/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ComunicazioneEmailAvvioDTO } from '../model/comunicazione-email-avvio-dto';
// @ts-ignore
import { ComunicazioneEmailDettaglioDTO } from '../model/comunicazione-email-dettaglio-dto';
// @ts-ignore
import { ComunicazioneEmailForm } from '../model/comunicazione-email-form';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelComunicazioneEmailInvioDTO } from '../model/paged-model-comunicazione-email-invio-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    ComunicazioniManualiEmailServiceInterface,
    GetDettaglioComunicazioneEmailRequestParams,
    GetStoricoComunicazioniEmailRequestParams,
    InviaComunicazioneEmailRequestParams
} from './comunicazioni-manuali-email.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ComunicazioniManualiEmailService extends BaseService implements ComunicazioniManualiEmailServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Dettaglio di un invio di email manuale, con l\&#39;esito per destinatario (SUPERADMIN, OP_COMUNE).
     * Testata dell\&#39;invio piu\&#39; corpo sanitizzato ed elenco dei destinatari con nome, cognome, esito (&#x60;IN_ATTESA&#x60;, &#x60;INVIATA&#x60;, &#x60;FALLITA&#x60;, &#x60;SALTATA_SENZA_EMAIL&#x60;) e &#x60;errore_codice&#x60; (&#x60;INDIRIZZO_NON_VALIDO&#x60;, &#x60;SMTP_RIFIUTATO&#x60;, &#x60;SMTP_NON_RAGGIUNGIBILE&#x60;, &#x60;ERRORE_INVIO&#x60;). Mai l\&#39;indirizzo email. &#x60;INVIATA&#x60; significa consegnata al server di posta, non letta.  Risposte: - 200: &#x60;ComunicazioneEmailDettaglioDTO&#x60;. - 403: caller ne\&#39; SUPERADMIN ne\&#39; OP_COMUNE. - 404: invio inesistente o di un comune fuori dal perimetro del caller.
     * @endpoint get /api/v1/gestione/comunicazioni-manuali/email/{id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getDettaglioComunicazioneEmail(requestParameters: GetDettaglioComunicazioneEmailRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ComunicazioneEmailDettaglioDTO>;
    public getDettaglioComunicazioneEmail(requestParameters: GetDettaglioComunicazioneEmailRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ComunicazioneEmailDettaglioDTO>>;
    public getDettaglioComunicazioneEmail(requestParameters: GetDettaglioComunicazioneEmailRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ComunicazioneEmailDettaglioDTO>>;
    public getDettaglioComunicazioneEmail(requestParameters: GetDettaglioComunicazioneEmailRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDettaglioComunicazioneEmail.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comunicazioni-manuali/email/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ComunicazioneEmailDettaglioDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Storico degli invii di email manuali (SUPERADMIN, OP_COMUNE).
     * Pagina dello storico, piu\&#39; recenti prima (il sort del client e\&#39; ignorato; massimo 100 righe). Un SUPERADMIN vede tutti gli invii, con &#x60;actor_snapshot&#x60;; un OP_COMUNE solo quelli con &#x60;comune_id&#x60; fra i propri comuni gestiti, anche se lanciati da un collega, e il mittente e\&#39; indicato solo da &#x60;mittente_nome&#x60;. &#x60;mittente_comune_nome&#x60; assente &#x3D; mittente di piattaforma. Nessun indirizzo email, nome di destinatario o nome di allegato. Oggetto e corpo restano per &#x60;civeshub.comunicazioni-email.ritenzione-testo-giorni&#x60; (default 90): &#x60;testo_disponibile_fino&#x60; dice fino a quando, &#x60;testo_rimosso_at&#x60; quando sono stati rimossi.  Risposte: - 200: &#x60;Page&lt;ComunicazioneEmailInvioDTO&gt;&#x60;. - 403: caller ne\&#39; SUPERADMIN ne\&#39; OP_COMUNE.
     * @endpoint get /api/v1/gestione/comunicazioni-manuali/email
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getStoricoComunicazioniEmail(requestParameters: GetStoricoComunicazioniEmailRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelComunicazioneEmailInvioDTO>;
    public getStoricoComunicazioniEmail(requestParameters: GetStoricoComunicazioniEmailRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelComunicazioneEmailInvioDTO>>;
    public getStoricoComunicazioniEmail(requestParameters: GetStoricoComunicazioniEmailRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelComunicazioneEmailInvioDTO>>;
    public getStoricoComunicazioniEmail(requestParameters: GetStoricoComunicazioniEmailRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling getStoricoComunicazioniEmail.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comunicazioni-manuali/email`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelComunicazioneEmailInvioDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Invia un\&#39;email a una selezione di cittadini (SUPERADMIN, OP_COMUNE).
     * Multipart: part &#x60;comunicazione&#x60; (JSON: &#x60;comune_id?&#x60;, &#x60;user_ids&#x60;, &#x60;oggetto&#x60;, &#x60;corpo_html&#x60;) e part opzionale &#x60;files&#x60; (allegati). Un messaggio separato per destinatario, mai in copia nascosta. Sono comunicazioni di servizio, non promozionali.  Perimetro e mittente: &#x60;comune_id&#x60; e\&#39; insieme il comune mittente e il perimetro dei destinatari (cittadini con almeno una pratica su un bando di quel comune; obbligatorio per un OP_COMUNE che ne gestisce piu\&#39; di uno, default se ne gestisce uno solo). Per un SUPERADMIN e\&#39; opzionale: assente &#x3D; mittente di piattaforma e nessun vincolo. Da 1 a 50 id distinti; i duplicati sono ridotti a uno.  Testo: &#x60;oggetto&#x60; e &#x60;corpo_html&#x60; ammettono i segnaposto &#x60;{{nome}}&#x60; e &#x60;{{cognome}}&#x60;. Il corpo e\&#39; sanitizzato dal server (restano p, br, strong/b, em/i, u, ol, ul, li e link http/https/mailto), al massimo 50000 caratteri dopo la sanitizzazione.  Allegati: al massimo 5 file e 10 MB in totale; estensioni pdf, png, jpg, jpeg, docx, xlsx, txt. Non sono conservati dopo l\&#39;invio.  Destinatari: cittadini con account attivato, non anonimizzati e non bloccati dal backoffice.  Cittadini senza email: riga &#x60;SALTATA_SENZA_EMAIL&#x60;, contati in &#x60;saltati_senza_email&#x60;. Se nessuno ha un\&#39;email l\&#39;invio nasce &#x60;FALLITO&#x60; e non parte nulla.  Risposte: - 202: invio preso in carico, non ancora spedito (&#x60;invio_id&#x60;, &#x60;destinatari_totali&#x60;, &#x60;saltati_senza_email&#x60;): l\&#39;esito si legge nel dettaglio. - 400: payload invalido, oggetto o corpo vuoti, corpo troppo lungo, allegati non ammessi o troppo grandi, elenco vuoto o oltre il tetto, &#x60;comune_id&#x60; mancante per un OP_COMUNE con piu\&#39; comuni. - 403: caller ne\&#39; SUPERADMIN ne\&#39; OP_COMUNE. - 404: comune fuori perimetro, oppure almeno un cittadino non idoneo o fuori perimetro (intera richiesta rifiutata, senza indicare quale id). - 503: troppi invii in corso; nulla e\&#39; stato salvato ne\&#39; spedito, si puo\&#39; riprovare.
     * @endpoint post /api/v1/gestione/comunicazioni-manuali/email
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public inviaComunicazioneEmail(requestParameters: InviaComunicazioneEmailRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ComunicazioneEmailAvvioDTO>;
    public inviaComunicazioneEmail(requestParameters: InviaComunicazioneEmailRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ComunicazioneEmailAvvioDTO>>;
    public inviaComunicazioneEmail(requestParameters: InviaComunicazioneEmailRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ComunicazioneEmailAvvioDTO>>;
    public inviaComunicazioneEmail(requestParameters: InviaComunicazioneEmailRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const comunicazione = requestParameters?.comunicazione;
        if (comunicazione === null || comunicazione === undefined) {
            throw new Error('Required parameter comunicazione was null or undefined when calling inviaComunicazioneEmail.');
        }
        const files = requestParameters?.files;

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (comunicazione !== undefined) {
            localVarFormParams = localVarFormParams.append('comunicazione', localVarUseForm ? new Blob([JSON.stringify(comunicazione)], {type: 'application/json'}) : <any>comunicazione) as any || localVarFormParams;
        }
        if (files) {
            if (localVarUseForm) {
                files.forEach((element) => {
                    localVarFormParams = localVarFormParams.append('files', <any>element) as any || localVarFormParams;
            })
            } else {
                localVarFormParams = localVarFormParams.append('files', [...files].join(COLLECTION_FORMATS['csv'])) as any || localVarFormParams;
            }
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comunicazioni-manuali/email`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ComunicazioneEmailAvvioDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
